import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { RouteReplayRoutingModule } from './route-replay-routing.module';
import { ShiftRouteSelectionComponent } from './components/shift-route-selection/shift-route-selection.component';
import { RouteReplayComponent } from './components/route-replay/route-replay.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { RouteRoutePlayerComponent } from './components/route-route-player/route-route-player.component';
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { DatepickerModuleV2 } from 'mis-crystal-design-system/datepicker_v2';
import { DropdownModule } from 'mis-crystal-design-system/dropdown';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { RouteDetailsComponent } from './components/side-bar/route-details/route-details.component';
import { VehiclesListComponent } from './components/side-bar/vehicles-list/vehicles-list.component';
import { StopsTimelineComponent } from './components/side-bar/stops-timeline/stops-timeline.component';
import { MultiSelectDropdownModule } from 'mis-crystal-design-system/multi-select-dropdown';
import { SwitchModule } from 'mis-crystal-design-system/switch';

@NgModule({
  declarations: [
    ShiftRouteSelectionComponent,
    RouteReplayComponent,
    MapViewComponent,
    RouteRoutePlayerComponent,
    SideBarComponent,
    RouteDetailsComponent,
    VehiclesListComponent,
    StopsTimelineComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    RouteReplayRoutingModule,
    LoaderModule,
    DatepickerModuleV2,
    DropdownModule,
    MultiSelectDropdownModule,
    SwitchModule
  ]
})
export class RouteReplayModule { }
